module.exports = {"320611001":"永兴街道","320611002":"唐闸镇街道","320611003":"天生港镇街道","320611004":"秦灶街道","320611005":"陈桥街道","320611006":"幸福街道","320611400":"港闸开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320611.json
// module id = 876
// module chunks = 0